import React, { useState } from 'react';
import { Modal, Button, Loader, Dimmer } from 'semantic-ui-react';

import { TranslationComponent } from '../TranslationComponent';
import { client } from '../../redux/store';

export const PtwImportModal: React.FC = () => {
  const [open, setOpen] = useState(false);
  const [file, setFile] = useState<File | null>(null);
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);

  const handleStartImport = () => {
    const data = new FormData();
    if (file) {
      data.append('file', file);
    }

    setLoading(true);

    client
      .post('ptw/import', data, { responseType: 'blob' })
      .then((value) => {
        const url = window.URL.createObjectURL(new Blob([value.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', file.name);
        document.body.appendChild(link);
        link.click();
        link.remove();
      })
      .finally(() => {
        setLoading(false);
        setDone(true);
      });
  };

  const handleClose = () => {
    setFile(null);
    setDone(false);
    setOpen(false);
  };

  return (
    <Modal
      open={open}
      onClose={() => setOpen(false)}
      trigger={
        <Button
          onClick={(event: any) => {
            event.stopPropagation();
            setOpen(true);
          }}
        >
          <TranslationComponent stringKey={'Import'} />
        </Button>
      }
      closeOnDocumentClick={false}
      closeOnEscape={false}
      closeOnDimmerClick={false}
    >
      <Modal.Header>
        <TranslationComponent stringKey={'Import PTWs'} />
      </Modal.Header>

      <Modal.Content>
        {loading ? (
          <Dimmer active inverted>
            <Loader inverted>Loading</Loader>
          </Dimmer>
        ) : done ? (
          <div>Import completato</div>
        ) : (
          <input
            type="file"
            onChange={(e) => {
              setFile(e.target.files[0]);
            }}
          />
        )}
      </Modal.Content>

      <Modal.Actions>
        {done ? (
          <Button primary onClick={handleClose}>
            <TranslationComponent stringKey={'Close'} />
          </Button>
        ) : (
          <>
            <Button onClick={() => setOpen(false)}>
              <TranslationComponent stringKey={'Cancel'} />
            </Button>

            <Button primary onClick={handleStartImport} disabled={!file}>
              <TranslationComponent stringKey={'Start'} />
            </Button>
          </>
        )}
      </Modal.Actions>
    </Modal>
  );
};
